<template>
  <el-dialog :close-on-click-modal="false" :visible="viewVisible" :modal-append-to-body="false" @close="$emit('closeView')">
    <el-tabs v-model="viewName">
      <el-tab-pane :label="$t('chong-dian-zhuang-xiang-qing')" name="detailForm">
        <el-form :model="detailForm" ref="detailForm" size="mini" class="detail_form">
          <el-collapse v-model="activeNames">
            <el-collapse-item :title="$t('ji-ben-xin-xi')" name="basicInformation">
              <el-col :span="12">
                <el-form-item :label="$t('chong-dian-zhuang-bian-hao')" :label-width="formLabelWidth" prop="pileCode">
                  <label v-text="detailForm.pileCode"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('chong-dian-zhuang-ming-cheng-0')" :label-width="formLabelWidth" prop="name">
                  <label v-text="detailForm.name"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('qiang-kou-shu-liang-0')" :label-width="formLabelWidth" prop="gunCount">
                  <label v-text="detailForm.gunCount"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('e-ding-gong-shuai-0')" :label-width="formLabelWidth" prop="ratedPower">
                  <label v-text="detailForm.ratedPower"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('shu-chu-dian-liu-fan-wei-0')" :label-width="formLabelWidth" prop="outputCurrentRange">
                  <label v-text="detailForm.outputCurrentRange"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('shi-fou-qi-yong')" :label-width="formLabelWidth" prop="enabledStateFlag">
                  <label v-if="detailForm.enabledStateFlag" v-text="detailForm.enabledStateFlag.message"></label>
                </el-form-item>
              </el-col>
              <!--                  <el-col :span="12">-->
              <!--                    <el-form-item label="桩运行状态：" :label-width="formLabelWidth" prop="runStatus">-->
              <!--                      <label v-if="detailForm.runStatus" v-text="detailForm.runStatus.message"></label>-->
              <!--                    </el-form-item>-->
              <!--                  </el-col>-->
              <el-col :span="12">
                <el-form-item :label="$t('ban-ben')" :label-width="formLabelWidth" prop="nowVersion">
                  <label v-text="detailForm.nowVersion"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('wang-luo-lian-jie-lei-xing')" :label-width="formLabelWidth" prop="networktype">
                  <label v-text="detailForm.networktype"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('xin-hao-fu-zhi')" :label-width="formLabelWidth" prop="signal">
                  <label v-text="detailForm.signal"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('tong-xin-mo-kuai-imei-hao-ma')" :label-width="formLabelWidth" prop="imei">
                  <label v-text="detailForm.imei"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('sim-ka-hao-ma')" :label-width="formLabelWidth" prop="sim">
                  <label v-text="detailForm.sim"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('chong-dian-jie-kou-biao-zhun-0')" :label-width="formLabelWidth" prop="chargingInterface">
                  <label v-if="detailForm.chargingInterface" v-text="detailForm.chargingInterface.message" autocomplete="off"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('fu-yuan-lei-xing-0')" :label-width="formLabelWidth" prop="auxiliarySourceType">
                  <label v-if="detailForm.auxiliarySourceType" v-text="detailForm.auxiliarySourceType.message" autocomplete="off"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('kuai-man-chong-0')" :label-width="formLabelWidth" prop="fastOrSlow">
                  <label v-if="detailForm.fastOrSlow" v-text="detailForm.fastOrSlow.message+$t('zhuang')"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
            <el-collapse-item :title="$t('bang-ding-xin-xi')" name="bindingInformation">
              <el-col :span="12">
                <el-form-item :label="$t('zhuang-ruan-jian-xie-yi')" :label-width="formLabelWidth" prop="protocol">
                  <label v-if="detailForm.protocol" v-text="detailForm.protocol.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('sheng-chan-chang-shang-0')" :label-width="formLabelWidth" prop="manufacturer">
                  <label v-text="detailForm.manufacturer"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('xing-hao-1')" :label-width="formLabelWidth" prop="pileTypeName">
                  <label v-text="detailForm.pileTypeModel"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('yun-ying-shang')" :label-width="formLabelWidth" prop="operatorName">
                  <label v-text="detailForm.operatorName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('chang-zhan')" :label-width="formLabelWidth" prop="stationName">
                  <label v-text="detailForm.stationName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('fei-shuai-zu')" :label-width="formLabelWidth" prop="serviceBillingRulesName">
                  <label v-text="detailForm.serviceBillingRulesName"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
            <el-collapse-item :title="$t('ri-qi-xin-xi')" name="dateInformation">
              <el-col :span="12">
                <el-form-item :label="$t('an-zhuang-ri-qi-0')" :label-width="formLabelWidth" prop="installDate">
                  <label v-text="detailForm.installDate"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('sheng-chan-ri-qi-0')" :label-width="formLabelWidth" prop="produceDate">
                  <label v-text="detailForm.produceDate"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('mian-fei-yun-ying-shi-jian-0')" :label-width="formLabelWidth" prop="freeOperatingTime">
                  <label v-text="detailForm.freeOperatingTime"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </el-tab-pane>
      <el-tab-pane :label="$t('bang-ding-jie-bang-fei-shuai')" name="bindingRateForm" v-if="checkPermission(['bee:res:pile:bindingRate'])">
        <el-form :model="bindingRateForm" ref="bindingRateForm" style="height: 400px" size="mini" class="bindingRateForm" :rules="bindingRateFormRules">
          <div v-if="bindingRateForm.serviceBillingRulesId">
            <el-col :span="24">
              <el-form-item :label="$t('fei-shuai-1')" :label-width="formLabelWidth" prop="ruleName">
                <label>{{bindingRateForm.ruleName}}</label>
                <el-button size="mini" plain style="margin-left: 10px" @click="unbinding">{{ $t('jie-bang') }}</el-button>
              </el-form-item>
            </el-col>
          </div>
          <div v-else>
            <el-col :span="24">
              <el-form-item :label="$t('fei-shuai-1')" :label-width="formLabelWidth" prop="serviceBillingRulesIdTemp">
                <el-select autocomplete="off" v-model="bindingRateForm.serviceBillingRulesIdTemp">
                  <el-option v-for="item in serviceBillingRulesSelect" :key="item.id"
                             v-bind:label="item.ruleName" v-bind:value="item.id"></el-option>
                </el-select>
                <el-button size="mini" plain style="margin-left: 10px" @click="dobinding">{{ $t('bang-ding') }}</el-button>
              </el-form-item>
            </el-col>
          </div>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="充电桩充电枪数图片" name="newUploadPileConnNumPicPictures" v-if="checkPermission(['bee:res:pile:uploadPileConnNumPic'])">
        <el-form :model="newUploadPileConnNumPicForm" ref="newUploadPileConnNumPicForm" size="mini" style="height: 400px" class="pileConnNumPicForm">
          <el-upload
            :action="uploadImage()"
            :on-preview="handlePileConnNumPicPreview"
            :on-remove="handlePileConnNumPicRemove"
            :before-upload="uploadPileConnNumPicFormBeforeUpload"
            :on-success="pileConnNumPicUploadSuccess"
            :on-error="uploadError"
            :on-exceed="upExceed"
            :limit="20"
            :file-list="newUploadPileConnNumPicList"
            list-type="picture-card"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="pileConnNumPicDialogVisible">
            <img width="100%" :src="pileConnNumPicDialogImageUrl" alt="">
          </el-dialog>
        </el-form>
        <el-button size="mini" plain @click="viewVisible = false">{{ $t('qu-xiao') }}</el-button>
        <el-button size="mini" plain type="primary" @click="pileConnNumPicUploadImage">{{ $t('ti-jiao') }}</el-button>
      </el-tab-pane>

      <el-tab-pane label="充电桩检测图片" name="newUploadCheckReportPictures" v-if="checkPermission(['bee:res:pile:uploadPileCheckReport'])">
        <el-form :model="newUploadCheckReportForm" ref="newUploadCheckReportForm" size="mini" style="height: 400px" class="pileConnNumPicForm">
          <el-upload
            :action="uploadImage()"
            :on-preview="handleCheckReportPreview"
            :on-remove="handleCheckReportRemove"
            :before-upload="uploadPileConnNumPicFormBeforeUpload"
            :on-success="checkReportUploadSuccess"
            :on-error="uploadError"
            :on-exceed="upExceed"
            :limit="20"
            :file-list="newUploadCheckReportList"
            list-type="picture-card"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="checkReportDialogVisible">
            <img width="100%" :src="checkReportDialogImageUrl" alt="">
          </el-dialog>
        </el-form>
        <el-button size="mini" plain @click="viewVisible = false">{{ $t('qu-xiao') }}</el-button>
        <el-button size="mini" plain type="primary" @click="checkReportUploadImage">{{ $t('ti-jiao') }}</el-button>
      </el-tab-pane>

      <el-tab-pane label="充电桩铭牌图片" name="newUploadCardPictures" v-if="checkPermission(['bee:res:pile:uploadPileCard'])">
        <el-form :model="newUploadCardForm" ref="newUploadCardForm" size="mini" style="height: 400px" class="pileConnNumPicForm">
          <el-upload
            :action="uploadImage()"
            :on-preview="handleCardPreview"
            :on-remove="handleCardRemove"
            :before-upload="uploadPileConnNumPicFormBeforeUpload"
            :on-success="cardUploadSuccess"
            :on-error="uploadError"
            :on-exceed="upExceed"
            :limit="20"
            :file-list="newUploadCardList"
            list-type="picture-card"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="cardDialogVisible">
            <img width="100%" :src="cardDialogImageUrl" alt="">
          </el-dialog>
        </el-form>
        <el-button size="mini" plain @click="viewVisible = false">{{ $t('qu-xiao') }}</el-button>
        <el-button size="mini" plain type="primary" @click="cardUploadImage">{{ $t('ti-jiao') }}</el-button>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
  import sysConfig from '@/../config/sysConfig'
  import service from '@/../config/serviceList'
  import pileApi from "../../../resourceCenter/api/pileApi";
  export default {
    name: "customizeView",
    data(){
      return{
        viewName: 'detailForm',
        activeNames: ['basicInformation', 'bindingInformation', 'dateInformation'],
        formLabelWidth: '150px',
        bindingRateFormRules:{
          serviceBillingRulesIdTemp:[{required: true, message: this.$t('qing-xuan-ze-fei-shuai'), trigger: 'blur'}]
        },
        pileConnNumPicDialogImageUrl:'',
        pileConnNumPicDialogVisible:false,
        checkReportDialogImageUrl:'',
        checkReportDialogVisible:false,
        cardDialogImageUrl:'',
        cardDialogVisible:false,
      }
    },
    props:{
      viewVisible:{
        type:Boolean,
        required: true
      },
      detailForm: {},
      bindingRateForm: {},
      serviceBillingRulesSelect: {},
      serviceBillingRulesIdTemp: '',
      newUploadPileConnNumPicForm:{},
      pileConnNumPicImageUrlList:{
        type:Array
      },
      newUploadPileConnNumPicList:{
        type:Array
      },
      newUploadCheckReportForm:{},
      checkReportImageUrlList:{
        type:Array
      },
      newUploadCheckReportList:{
        type:Array
      },
      newUploadCardForm:{},
      cardImageUrlList:{
        type:Array
      },
      newUploadCardList:{
        type:Array
      },
    },
    methods:{
      uploadImage() {
        return sysConfig.apiPre + service.ops + "/ops/upload/image_upload";
      },
      handlePileConnNumPicPreview(file) {
        this.pileConnNumPicDialogImageUrl = file.url;
        this.pileConnNumPicDialogVisible = true;
      },
      handleCheckReportPreview(file) {
        this.checkReportDialogImageUrl = file.url;
        this.checkReportDialogVisible = true;
      },
      handleCardPreview(file) {
        this.cardDialogImageUrl = file.url;
        this.cardDialogVisible = true;
      },
      uploadPileConnNumPicFormBeforeUpload(file){
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error("上传头像图片大小不能超过 2MB!");
        }
        return isLt2M
      },
      pileConnNumPicUploadImage(){
        console.log(this.newUploadPileConnNumPicForm);
        this.newUploadPileConnNumPicForm.images=this.pileConnNumPicImageUrlList;
        pileApi.uploadPileConnNumPic(this.newUploadPileConnNumPicForm).then((res) => {
          if (res.code === 0) {
            this.$message({
              message: res.message,
              type: 'success'
            });
            this.$emit("closeView")
            this.$emit('submitSearchForm')
            this.$emit('revertPileFileList')
          } else {
            this.$message.error(res.message)
          }
        })
      },
      checkReportUploadImage(){
        console.log(this.newUploadCheckReportForm);
        this.newUploadCheckReportForm.images=this.checkReportImageUrlList;
        pileApi.uploadPileCheckReport(this.newUploadCheckReportForm).then((res) => {
          if (res.code === 0) {
            this.$message({
              message: res.message,
              type: 'success'
            });
            this.$emit("closeView")
            this.$emit('submitSearchForm')
            this.$emit('revertPileFileList')
          } else {
            this.$message.error(res.message)
          }
        })
      },
      cardUploadImage(){
        console.log(this.newUploadCardForm);
        this.newUploadCardForm.images=this.cardImageUrlList;
        pileApi.uploadPileCard(this.newUploadCardForm).then((res) => {
          if (res.code === 0) {
            this.$message({
              message: res.message,
              type: 'success'
            });
            this.$emit("closeView")
            this.$emit('submitSearchForm')
            this.$emit('revertPileFileList')
          } else {
            this.$message.error(res.message)
          }
        })
      },
      pileConnNumPicUploadSuccess(response,file,fileList){
        console.log(response);
        if(response.code===0){
          console.log(response.data);
          file.name=response.data;
          this.pileConnNumPicImageUrlList.push(response.data);
        }else{
          this.$message({
            type: 'error',
            message: "文件上传失败，请稍后重试"
          });
        }
      },
      checkReportUploadSuccess(response,file,fileList){
        console.log(response);
        if(response.code===0){
          console.log(response.data);
          file.name=response.data;
          this.checkReportImageUrlList.push(response.data);
        }else{
          this.$message({
            type: 'error',
            message: "文件上传失败，请稍后重试"
          });
        }
      },
      cardUploadSuccess(response,file,fileList){
        console.log(response);
        if(response.code===0){
          console.log(response.data);
          file.name=response.data;
          this.cardImageUrlList.push(response.data);
        }else{
          this.$message({
            type: 'error',
            message: "文件上传失败，请稍后重试"
          });
        }
      },
      uploadError(err,file,fileList){
        console.log(err);
        this.$message({
          type: 'error',
          message: "文件上传失败，请稍后重试"
        });
      },
      upExceed(file,fileList){
        this.$message({
          type: 'info',
          message: "最多只能上传20张图片"
        });
      },
      handlePileConnNumPicRemove(file, fileList) {
        console.log(file);
        console.log(this.pileConnNumPicImageUrlList);
        this.pileConnNumPicImageUrlList.splice(this.pileConnNumPicImageUrlList.findIndex(item => item === file.name), 1);
        console.log(this.pileConnNumPicImageUrlList);
      },
      handleCheckReportRemove(file, fileList) {
        console.log(file);
        console.log(this.checkReportImageUrlList);
        this.checkReportImageUrlList.splice(this.checkReportImageUrlList.findIndex(item => item === file.name), 1);
        console.log(this.checkReportImageUrlList);
      },
      handleCardRemove(file, fileList) {
        console.log(file);
        console.log(this.cardImageUrlList);
        this.cardImageUrlList.splice(this.cardImageUrlList.findIndex(item => item === file.name), 1);
        console.log(this.cardImageUrlList);
      },
      unbinding(){
        this.$emit("unbinding")
      },
      dobinding(){
        this.$emit("dobinding",this.$refs["bindingRateForm"])
      },
    }
  }
</script>

<style scoped lang="less">
  /deep/ .uploadSitePicForm

  {
    height: 550px;
    overflow: auto;

    .el-form-item__label {
      color: rgba(0, 0, 0, 0.47);
    }
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 10px;
    margin-right: 10px;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
    margin-top: 10px;
    margin-right: 10px;
  }

  .pileConnNumPicForm{
    text-align: left;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/deviceManager/customizeView.vue